import { IMenuItem } from './';
import { mainMenuTypes } from './menu.enum';

export let mainMenu: IMenuItem[] = [
    {
        id: mainMenuTypes.SystemManager,
        name: 'SYSTEM_MANAGEMENT',
        matchedLabel: 'APP_SYSTEM_MANAGEMENT',
        component: 'SystemManagerPage',
        icon: 'system-manager',
        requiresPermission: true,
        linkChunk: 'system',
        isParent: true,
        children: [
            {
                id: mainMenuTypes.Tenants,
                name: 'APP_TENANTS',
                matchedLabel: 'APP_TENANTS',
                component: 'LaunchPadPage',
                requiresPermission: true,
                linkChunk: 'tenants',
                link: '/system/tenants',
                parentId: mainMenuTypes.SystemManager
            },
            {
                id: mainMenuTypes.ScheduledJobs,
                name: 'APP_JOBS',
                matchedLabel: 'APP_JOBS',
                component: 'ScheduledJobsPage',
                requiresPermission: true,
                linkChunk: 'jobs',
                link: '/system/jobs',
                parentId: mainMenuTypes.SystemManager
            },
            {
                id: mainMenuTypes.Notifications,
                name: 'APP_NOTIFICATION',
                matchedLabel: 'APP_NOTIFICATION',
                component: 'LaunchPadPage',
                requiresPermission: true,
                linkChunk: 'notifications',
                link: '/system/notifications',
                parentId: mainMenuTypes.SystemManager
            },
        ]
    },
    {
        id: mainMenuTypes.GettingStarted,
        name: 'GETTINGSTARTED_TITLE',
        matchedLabel: 'GETTING_STARTED',
        component: 'GettingStartedPage',
        icon: 'getting-started',
        requiresPermission: true,
        linkChunk: 'getting-started',
        link: '/getting-started'
    },
    {
        id: mainMenuTypes.DirectoryManager,
        name: 'APP_DIRECTORY_MANAGER',
        matchedLabel: 'APP_DIRECTORY_MANAGER',
        component: 'DirectoryManagerPage',
        icon: 'directory-manager',
        requiresPermission: true,
        linkChunk: 'directory',
        isParent: true,
        children: [
            {
                id: mainMenuTypes.Users,
                name: 'APP_USERS',
                matchedLabel: 'APP_USERS',
                component: 'DirectoryManagerPage',
                requiresPermission: true,
                linkChunk: 'users',
                link: '/directory/users',
                parentId: mainMenuTypes.DirectoryManager
            },
            {
                id: mainMenuTypes.Groups,
                name: 'APP_GROUPS',
                matchedLabel: 'APP_GROUPS',
                component: 'DirectoryManagerPage',
                requiresPermission: true,
                linkChunk: 'groups',
                link: '/directory/groups',
                parentId: mainMenuTypes.DirectoryManager
            },
            {
                id: mainMenuTypes.Roles,
                name: 'APP_ROLES',
                matchedLabel: 'APP_ROLES',
                component: 'DirectoryManagerPage',
                requiresPermission: true,
                linkChunk: 'roles',
                link: '/directory/roles',
                parentId: mainMenuTypes.DirectoryManager
            },
            {
                id: mainMenuTypes.Organizations,
                name: 'APP_ORGS',
                matchedLabel: 'APP_ORGS',
                component: 'DirectoryManagerPage',
                requiresPermission: true,
                linkChunk: 'orgs',
                link: '/directory/orgs',
                parentId: mainMenuTypes.DirectoryManager
            },
            {
                id: mainMenuTypes.DirectorySync,
                name: 'APP_SYNC',
                matchedLabel: 'APP_SYNC',
                component: 'DirectoryManagerPage',
                requiresPermission: true,
                linkChunk: 'sync',
                link: '/directory/sync',
                parentId: mainMenuTypes.DirectoryManager
            }
        ]
    },
    {
        id: mainMenuTypes.PasswordServer,
        name: 'APP_PASSWORD_MANAGER',
        matchedLabel: 'APP_PASSWORD_MANAGER',
        component: 'PasswordServerPage',
        icon: 'password-server',
        requiresPermission: true,
        linkChunk: 'passwordserver',
        isParent: true,
        children: [
            {
                id: mainMenuTypes.PasswordReminders,
                name: 'PASSWORD_SERVER_REMINDERS',
                matchedLabel: 'PASSWORD_SERVER_REMINDERS',
                component: 'PasswordServerPage',
                requiresPermission: true,
                linkChunk: 'passwordreminders',
                link: '/passwordserver/passwordreminders',
                parentId: mainMenuTypes.PasswordServer
            },
            {
                id: mainMenuTypes.VaultManager,
                name: 'APP_VAULT_MANAGER',
                matchedLabel: 'APP_VAULT_MANAGER',
                component: 'PasswordServerPage',
                requiresPermission: true,
                linkChunk: 'vaults',
                link: '/passwordserver/vaults',
                parentId: mainMenuTypes.PasswordServer
            },
            {
                id: mainMenuTypes.PasswordPolicy,
                name: 'VAULT_PASSWORD_POLICY',
                matchedLabel: 'ORG_PASS_POLICY',
                component: 'PasswordServerPage',
                requiresPermission: true,
                linkChunk: 'passwordserverpolicy',
                link: '/passwordserver/passwordserverpolicy',
                parentId: mainMenuTypes.PasswordServer
            },
            {
                id: mainMenuTypes.Agents,
                name: 'APP_VAULT_AGENTS',
                matchedLabel: 'APP_VAULT_AGENTS',
                component: 'PasswordServerPage',
                requiresPermission: true,
                linkChunk: 'agents',
                link: '/passwordserver/agents',
                parentId: mainMenuTypes.PasswordServer
            },
            {
                id: mainMenuTypes.MigrateFromOnPremise,
                name: 'APP_VAULT_IMPORT',
                matchedLabel: 'APP_VAULT_IMPORT',
                component: 'PasswordServerPage',
                requiresPermission: true,
                linkChunk: 'import',
                link: '/passwordserver/import',
                parentId: mainMenuTypes.PasswordServer
            }
        ]
    },
    {
        id: mainMenuTypes.PasswordManager2,
        name: 'APP_PASSWORD_MANAGER_2',
        matchedLabel: 'APP_PASSWORD_MANAGER_2',
        component: 'PasswordServerPage2',
        icon: 'password-server',
        requiresPermission: true,
        linkChunk: 'password-manager',
        isParent: true,
        children: [
/*            {
                id: mainMenuTypes.PasswordReminders2,
                name: 'PASSWORD_SERVER_REMINDERS',
                matchedLabel: 'PASSWORD_SERVER_REMINDERS',
                component: 'PasswordServerPage2',
                requiresPermission: true,
                linkChunk: 'passwordreminders',
                link: '/password-manager/passwordreminders',
                parentId: mainMenuTypes.PasswordManager2
            },*/
            {
                id: mainMenuTypes.VaultManager2,
                name: 'APP_VAULT_MANAGER',
                matchedLabel: 'PASSWORD_MANAGER_VAULTS',
                component: 'PasswordServerPage2',
                requiresPermission: true,
                linkChunk: 'vaults',
                link: '/password-manager/vaults',
                parentId: mainMenuTypes.PasswordManager2
            },
            {
                id: mainMenuTypes.PasswordPolicy2,
                name: 'VAULT_PASSWORD_POLICY',
                matchedLabel: 'PASSWORD_MANAGER_PASSWORD_POLICIES',
                component: 'PasswordServerPage2',
                requiresPermission: true,
                linkChunk: 'password-policies',
                link: '/password-manager/password-policies',
                parentId: mainMenuTypes.PasswordManager2
            },
/*            {
                id: mainMenuTypes.Agents2,
                name: 'APP_VAULT_AGENTS',
                matchedLabel: 'APP_VAULT_AGENTS',
                component: 'PasswordServerPage2',
                requiresPermission: true,
                linkChunk: 'agents',
                link: '/password-manager/agents',
                parentId: mainMenuTypes.PasswordManager2
            },
            {
                id: mainMenuTypes.MigrateFromOnPremise2,
                name: 'APP_VAULT_IMPORT',
                matchedLabel: 'APP_VAULT_IMPORT',
                component: 'PasswordServerPage2',
                requiresPermission: true,
                linkChunk: 'import',
                link: '/password-manager/import',
                parentId: mainMenuTypes.PasswordManager2
            }*/
        ]
    },
    {
        id: mainMenuTypes.Reports,
        name: 'REPORT_MANAGER',
        matchedLabel: 'REPORTING',
        component: 'ReportManagerPage',
        icon: 'report-manager',
        requiresPermission: true,
        linkChunk: 'password-server',
        link: '/reporting/password-server'
    },
    {
        id: mainMenuTypes.JIT,
        name: 'JUST_IN_TIME_AUTH',
        matchedLabel: 'JUST_IN_TIME_AUTH',
        component: 'JITPage',
        icon: 'jit2fa',
        requiresPermission: false,
        linkChunk: 'jit',
        isParent: true,
        children: [
            {
                id: mainMenuTypes.JITUsers,
                name: 'APP_JIT_USERS',
                matchedLabel: 'APP_JIT_USERS',
                component: 'JITPage',
                requiresPermission: false,
                linkChunk: 'jitters',
                link: '/jit/jitters',
                parentId: mainMenuTypes.JIT
            }
        ]
    },
    {
        id: mainMenuTypes.AuthManager,
        name: 'APP_AUTH_MANAGER',
        matchedLabel: 'APP_AUTH_MANAGER',
        component: 'AuthManagerPage',
        icon: 'auth-manager',
        requiresPermission: true,
        linkChunk: 'auth',
        isParent: true,
        children: [
            {
                id: mainMenuTypes.AuthManagerAgents,
                name: 'APP_AUTH_AGENTS_AND_CLIENTS',
                matchedLabel: 'APP_AUTH_AGENTS_AND_CLIENTS',
                component: 'AuthManagerPage',
                requiresPermission: true,
                linkChunk: 'agents',
                link: '/auth/agents',
                parentId: mainMenuTypes.AuthManager
            },
            {
                id: mainMenuTypes.Logs,
                name: 'APP_LOGS',
                matchedLabel: 'APP_LOGS',
                component: 'AuthManagerPage',
                requiresPermission: true,
                linkChunk: 'logs',
                link: '/auth/logs',
                parentId: mainMenuTypes.AuthManager
            },
            {
                id: mainMenuTypes.ApiExplorer,
                name: 'API_EXPLORER',
                matchedLabel: 'APP_API_EXPLORER',
                component: 'AuthManagerPage',
                requiresPermission: true,
                linkChunk: 'api-explorer',
                link: '/auth/api-explorer',
                parentId: mainMenuTypes.AuthManager
            }
        ]
    },
    {
        id: mainMenuTypes.IntegrationManager,
        name: 'APP_INTEGRATION_MANAGER',
        matchedLabel: 'INTEGRATIONS',
        component: 'LicenseManagerPage',
        icon: 'plug',
        requiresPermission: true,
        linkChunk: 'integrations',
        link: '/integrations',
        /* isParent: false,
        children: [
            {          id: mainMenuTypes.DarkwebCompromise,
                name: 'APP_DARKWEB_COMPROMISE_WORKFLOW',
                matchedLabel: 'INTEGRATIONS_DARKWEB',
                component: 'LicenseManagerPage',
                requiresPermission: true,
                linkChunk: 'darkweb',
                link: '/integrations/darkweb',
                parentId: mainMenuTypes.IntegrationManager

            ]}*/
    },
    {
        id: mainMenuTypes.PolicyManager,
        name: 'POLICY_MANAGER',
        matchedLabel: 'POLICY_MANAGER',
        component: 'PolicyManagerPage',
        icon: 'policy-manager',
        requiresPermission: true,
        linkChunk: 'policies',
        isParent: true,
        children: [
            {
                id: mainMenuTypes.Authentication,
                name: 'AUTH_POLICIES',
                matchedLabel: 'AUTH_POLICIES',
                component: 'PolicyManagerPage',
                requiresPermission: true,
                linkChunk: 'auth',
                link: '/policies/auth',
                parentId: mainMenuTypes.PolicyManager
            },
            {
                id: mainMenuTypes.Provisioning,
                name: 'PROVISIONING_POLICIES',
                matchedLabel: 'PROVISIONING_POLICIES',
                component: 'PolicyManagerPage',
                requiresPermission: true,
                linkChunk: 'provisioning',
                link: '/policies/provisioning',
                parentId: mainMenuTypes.PolicyManager
            }
        ]
    },
    {
        id: mainMenuTypes.SSOManager,
        name: 'APP_SSO_MANAGER',
        matchedLabel: 'APP_SSO_MANAGER',
        component: 'SSOManagerPage',
        icon: 'sso-manager',
        requiresPermission: true,
        linkChunk: 'sso',
        isParent: true,
        children: [
            {
                id: mainMenuTypes.ApplicationLibrary,
                name: 'APP_APP_LIBRARY',
                matchedLabel: 'APP_APP_LIBRARY',
                component: 'SSOManagerPage',
                requiresPermission: true,
                linkChunk: 'library',
                link: '/sso/library',
                parentId: mainMenuTypes.SSOManager
            },
            {
                id: mainMenuTypes.WorkflowRequests,
                name: 'APP_WORKFLOW_REQUESTS',
                matchedLabel: 'APP_WORKFLOW_REQUESTS',
                component: 'SSOManagerPage',
                requiresPermission: true,
                linkChunk: 'requests',
                link: '/sso/requests',
                parentId: mainMenuTypes.SSOManager
            },
            {
                id: mainMenuTypes.SystemCatalog,
                name: 'APP_APP_CATALOG',
                matchedLabel: 'APP_WORKFLOW_CATALOG',
                component: 'SSOManagerPage',
                requiresPermission: true,
                linkChunk: 'syscatalog',
                link: '/sso/syscatalog',
                parentId: mainMenuTypes.SSOManager
            },
            {
                id: mainMenuTypes.WorkflowErrors,
                name: 'APP_WORKFLOW_FAILURE',
                matchedLabel: 'APP_WORKFLOW_FAILURE',
                component: 'SSOManagerPage',
                requiresPermission: true,
                linkChunk: 'sysfailure',
                link: '/sso/sysfailure',
                parentId: mainMenuTypes.SSOManager
            }
        ]
    },
    {
        id: mainMenuTypes.LicenseManager,
        name: 'APP_LICENSE_MANAGER',
        matchedLabel: 'APP_LICENSE_MANAGER',
        component: 'LicenseManagerPage',
        icon: 'license-manager',
        requiresPermission: true,
        linkChunk: 'license',
        isParent: true,
        children: [
            {
                id: mainMenuTypes.LicenseAllocation,
                name: 'APP_LICENSE_ALLOCATION',
                matchedLabel: 'APP_LICENSE_ALLOCATION',
                component: 'LicenseManagerPage',
                requiresPermission: true,
                linkChunk: 'allocation',
                link: '/license/allocation',
                parentId: mainMenuTypes.LicenseManager
            }
        ]
    },
    {
        id: mainMenuTypes.KaseyaOne,
        name: 'KASEYA_ONE',
        matchedLabel: 'APP_KASEYA_ONE_MANAGER',
        component: 'KaseyaOnePage',
        icon: 'kaseyaOne',
        requiresPermission: true,
        linkChunk: 'kaseyaone',
        link: '/kaseyaone'
    },
];
